import { Link, navigate } from 'gatsby'

import { FaqRoutingProvider, FaqSessionProvider } from '@karakuri-web/faq-component'

import { Session } from './session'

import type { WrapRootElementBrowserArgs, WrapRootElementNodeArgs } from 'gatsby'

const faqSession = {
  getValue: () => Session.get(),
}

export function wrapRootElement({ element }: WrapRootElementBrowserArgs | WrapRootElementNodeArgs) {
  return (
    <FaqSessionProvider session={faqSession}>
      <FaqRoutingProvider navigate={navigate} Link={Link}>
        {element}
      </FaqRoutingProvider>
    </FaqSessionProvider>
  )
}
